import { ConnectConsoleProxy } from "./internal/util/ConnectConsoleProxy";

console = ConnectConsoleProxy;

export * from "./internal/geoServiceInstance";
export * from "./internal/GeoService";
export * from "./internal/ServiceCache";
export * from "./internal/ListenerManager";
export * from "./internal/OnDataReadyListener";
export * from "./internal/AdditionalHeaders";
export * from "./internal/util/ConnectConsoleProxy";
